import Action from "./action";

export default class LoadState extends Action {
    states;
    patchState;
    loadViewpoint;
    appendState;
    viewpointApplyMode;

    constructor(props) {
        super(props);
        this.states = props.states || [];
        this.disabled = props.disabled;
        this.patchState = props.patchState ? props.patchState : false;
        this.loadViewpoint = !!props.loadViewpoint;
        this.appendState = props.appendState ? props.appendState : false;
        this.viewpointApplyMode = props.viewpointApplyMode || '2D';
    }

    async execute(eventLoop) {
        const training = eventLoop.training;

        if (await Action.parseValue(this.disabled, eventLoop)) {
            return;
        }

        training.prepareStates(this.states);
        await training.loadStates({
            patchState: this.patchState,
            loadViewpoint: this.loadViewpoint,
            appendState: this.appendState,
            viewpointApplyMode: this.viewpointApplyMode
        });
    }
}
